// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3444) return "static/chunks/3444.3bf5685dd95d34aa.js";
	if (chunkId === 8766) return "static/chunks/8766.9f2a04a46dcdda1f.js";
	if (chunkId === 2894) return "static/chunks/2894.284bf6a07b652a8c.js";
	if (chunkId === 968) return "static/chunks/968.3b8edd78fec677db.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"277":"54a60aa6","5004":"70e0d97a","6711":"8e1d74a4"}[chunkId] || chunkId) + "-" + {"277":"87330e9ef7c16177","1213":"e9d44eeff1af9cb8","4088":"2f387962ea95f1ea","5004":"42afd270ef4868b2","6711":"13634dae8b05e5a0"}[chunkId] + ".js";
};